import React from 'react';

interface Props {
  children: any;
  isRakutenCoJpDomain: boolean;
  onLoad: Function;
}

export const Header = (props: Props) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: props.children,
      }}
    />
  );
};
